import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip
        {...props}
        arrow
        classes={{ popper: className }}
        placement={props.placement || 'right'}
        slotProps={{
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -8],
                        },
                    },
                ],
            },
        }}
    />
))(
    ({ theme }) => `
    .${tooltipClasses.arrow} {
      color: ${theme.nav.default}
    }
    .${tooltipClasses.tooltip} {
      background-color: ${theme.nav.default};
      text-align: center;
      padding-top: 0,
      padding-bottom: 0;
      border-radius: 6.6px;
      display: flex;
      align-items: center;
    },
  `,
);
